// @create-index

export { default as configureServiceWorker } from './configureServiceWorker.js';

